module.exports = __webpack_public_path__ + "media/images/icons/on-going-class-color-icon-25c135fece8dc8f4b9aae28283e5f763.svg";